import CheckBoxDropdown from "components/common/checkbox-dropdown";
import PropTypes from "prop-types";
import IconArrowGreen from "assets/svg/chevron_right_green.svg";

import styles from "./styles.module.css";

const PoiButton = ({ visiblePoiTypes, onChange }) => {
  return (
    <div className={styles.poiButtonWrapper}>
      <CheckBoxDropdown
        placeHolder="Yakında Neler Var"
        options={visiblePoiTypes}
        buttonClass={styles.poiButton}
        placeHolderClass={styles.placeHolder}
        icon={<IconArrowGreen />}
        showImage={true}
        showCheckBoxFooter={true}
        displayClass={styles.poiDisplayClass}
        titleClass={styles.poiTitleClass}
        onChange={onChange}
        showDivider={true}
        dividerClass={styles.poiDividerClass}
        showOnlyText={true}
        listClass={styles.poiListClass}
        iconClass={styles.iconClass}
      />
    </div>
  );
};

PoiButton.propTypes = {
  visiblePoiTypes: PropTypes.array,
  onChange: PropTypes.func,
};

export default PoiButton;
